module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/tactical-training-50.e0d84634.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/tactical-training-50.png
// module id = 3802
// module chunks = 11